module.exports = __webpack_public_path__ + "img/testIcon.f99d47a0.svg";